interface SortTabsProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export default function SortTabs({ options, value, onChange }: SortTabsProps) {
  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1">
      {options.map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => onChange(option)}
          className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors ${
            option === value
              ? "bg-primary-500 text-background-50"
              : "text-foreground-600 hover:text-foreground-950"
          }`}
        >
          {option}
        </button>
      ))}
    </div>
  );
}